import React from 'react';

const Home: React.FC = () => {
    return (
        <div>
            <h1>Welcome to AdSpace Admin</h1>
            <p>Use the menu on the left to navigate through the admin panel.</p>
        </div>
    );
};

export default Home;